import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _authenticationService: AuthenticationService
  ) { }

  // canActivate
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let subdomain = localStorage.getItem('currentUserSubdomainMybenefits')
      ? localStorage.getItem('currentUserSubdomainMybenefits')
      : 'default';

    if (subdomain === undefined || subdomain === 'default') {
      // nothing in local storage yet, but we should check the current URL, maybe it's a direct link
      const routeSub = state.root.firstChild.params['subdomain'];
      if (routeSub) {
        subdomain = routeSub;
      }
    }

    const currentUser = this._authenticationService.currentUserValue;
    if (currentUser) {
      if(subdomain === undefined || subdomain === 'default'){
        // no company subdomain set
        this._router.navigate(['/']);
      }

      // check if route is restricted by role
      if (
        route.data.roles &&
        !route.data.roles.some((r) => currentUser.roles.indexOf(r) >= 0)
      ) {
        // role not authorised so redirect to not-authorized page
        this._router.navigate([
          '/' + subdomain + '/pages/miscellaneous/not-authorized',
        ]);
        return false;
      }
      // authorised so return true
      return true;
    }

    if(subdomain === undefined || subdomain === 'default'){
      // no company subdomain set
      this._router.navigate(['/']);
    } else {
      // not logged in so redirect to login page with the return url
      const returnUrl = state.url.includes('/authentication/') ? '/' : state.url;
      localStorage.setItem('returnUrl', returnUrl);
      this._router.navigate(['/' + subdomain + '/authentication/login']);
    }

    return false;
  }
}
